module.exports = __webpack_public_path__ + "img/product-vr1-m.e5fd1a49.jpg";